export const AccessoriesEnum = {
    ManigliaPlatinBronze: "ACCM01",
    ManigliaPlatinSilver: "ACCM31",
    DoppiaManigliaVerniciataSceltaRal: "ACCM32"
}